module.exports = __webpack_public_path__ + "static/media/PSDM_2.49720944.gif";